import { lazy } from 'react';

import merge from 'lodash/merge';

import { helocRouteHandlers } from '../flows/heloc/navigation/helocRouteHelper';
import defaultLogo from '../programs/Pesto/assets/pesto-logo.svg';

import type { BaseProgramConfig, HelocFlowConfig } from './program.types';
import { FlowType } from './programConfig';

const HelocRoutesLazy = lazy(() =>
  import('../flows/heloc/HelocRoutes').then(module => ({ default: module.HelocRoutes })),
);

const defaultConfig = {
  logo: defaultLogo,
  favicon: '/pesto-favicon.png',
  meta: {
    title: 'Default Application',
    description: 'Default Application',
  },
  texts: {
    cardName: 'Default Card',
    customerSupport: {
      phoneNumber: '(888) 221-9804',
      email: 'support@homelight.com',
    },
  },
  images: {},
};

const createDefaultFlow = <T extends BaseProgramConfig>(flowSpecificConfig: Partial<T>, config: Partial<T>): T => {
  const defaultFlowConfig = {
    ...defaultConfig,
    ...flowSpecificConfig,
  } as T;

  return merge({}, defaultFlowConfig, config);
};

export const createDefaultHelocFlow = (config: Partial<HelocFlowConfig>): HelocFlowConfig =>
  createDefaultFlow(
    {
      flowType: FlowType.HELOC,
      RouteComponent: HelocRoutesLazy,
      statusHandlers: helocRouteHandlers,
      layout: {
        header: {
          theme: 'light',
          removeLoginButton: true,
        },
        loginPage: {
          bgColor: '#ffffff',
        },
      },
    },
    config,
  );
